const cashbackTermsandConditions = [
    {
        headContent: "Definition:",
        subCategoryType: "1",
        subCategories: [
            {
                mainContent: `For the purposes of the Vahak-Cashback T&C, unless the context
                or meaning thereof otherwise requires, the following terms shall
                have the meanings ascribed to them below:`,
                subContents: [
                    ` <b>“Cashback Scheme(s)”</b> means the cashback schemes that
                    have been mentioned in the Vahak-Cashback T&C;`,
                    `<b>“Company”</b> or <b>“Vahak”</b> means Epictus Solutions India Private Limited which expression
                    shall include its parent company;`,
                    `<b>“Cumulative   Transaction   Cashback   Cap”</b> means   the   capping   of   the Cashback,
                    cumulatively for all Eligible Transactions as mentioned in the specific Cashback Scheme;`,
                    `<b>“Eligible Load Provider”</b> means the Load Provider who makes the payment for an
                    Eligible Transaction;`,
                    `<b>“Existing User”</b> shall mean such Load Provider, who has made any payment or a part
                    thereof using Vahak Payments before the commencement of the Validity Period;`,
                    `<b>“Individual Transaction Cashback Cap”</b> means the capping of the Cashback for that
                    Eligible Transaction, as mentioned in the specific Cashback Scheme;`,
                    `<b>“Load Provider”</b> shall mean and include Shipper, Transport Companies and Brokers, as
                    the case may be;`,
                    `<b>“Lorry   Provider”</b> shall   mean   and   include   Truck   Providers,   Transport Companies and
                    Brokers, as the case may be;`,
                    `<b>“New User”</b> shall mean such Load Provider or Lorry provider, who has not made nor received any payment or a part
                    thereof, using Vahak Payments before the commencement of the Validity Period;`,
                    `<b>“Platform(s)”</b> shall mean the mobile application by the name of Vahak: Book Online
                    Truck, Load available on google playstore and the website bearing the URL
                    <a href="https://www.vahak.in/">https://www.vahak.in/</a>;`,
                    `<b>“User(s)”</b> shall mean the Existing User(s) and the New User(s), collectively;`,
                    `<b>“Vahak- Cashback T&C”</b> shall mean the terms and conditions contained herein;`,
                    `<b>“Vahak Payment”</b> refers to a transaction between a Load Provider and Lorry Provider
                    wherein the entire payment for the transaction is made on the Platform;`,
                    `<b>“Validity Period’”</b> shall mean a transaction made on and between <b>April 11, 2022</b> and
                    <b>March 31, 2023</b> (both days inclusive) or such period as maybe decided by the
                    Company, which may be earlier to or later than the date contained herein;`
                ]
            },
            {
                mainContent: `In these, unless the context or meaning thereof otherwise requires:`,
                subContents: [
                    `Words referring to a particular gender are deemed to include the other gender;`,
                    `Words using the singular or plural number also include the plural or singular number, 
                    respectively;`,
                    `The terms “hereof”, ‘herein”, “hereby”, “hereto” and derivative or similar words refer to
                    this entire Vahak- Cashback T&C;`,
                    `The term “clause” refers to the specified clause of this Vahak- Cashback T&C;`,
                    `Reference to any legislation or law or to any provision thereof shall include references to
                    any such law as it may, after the date hereof, from time to time, be amended,
                    supplemented or re-enacted, and any reference to a statutory provision shall include any
                    subordinate legislation made from time to time under that provision;`,
                    `Any term or expression used but not defined herein shall have the same meaning
                    attributable to it under applicable laws;`,
                    `References to the word “include” or “including” shall be construed without limitation;`,
                    `Each of the representations, warranties and undertakings contained hereof shall be
                    separate and independent and shall not be limited by reference to any other clause or by
                    anything in this Vahak- Cashback T&C;`,
                    `In the event of any disagreement, the decision of the Company shall be final and binding;
                    and`,
                    `re-enacted, and any reference to a statutory provision shall include any subordinate
                    legislation made from time to time under that provision.`
                ]
            }
        ]
    },
    {
        headContent: `The purpose of the Vahak-Cashback T&C is to specify and mention in clear terms, the terms
        and conditions that govern the Cashback Scheme, being referred to herein. The Vahak-
        Cashback T&C are applicable to determine the Cashback on the payment made by the Load
        Provider to Lorry Provider using Vahak Payment.`
    },
    {
        headContent: `<b>IT IS ADVISED THAT BEFORE MAKING ANY PAYMENT USING VAHAK PAYMENT -A
        USER SHOULD THOROUGHLY READ, UNDERSTAND AND THEN ACCEPT THE DISCLAIMER AND THE
        GUIDELINE BY LORRY PROVIDER. THE UNDERTAKING AND
        GUIDELINE SHALL BE DEEMED INCORPORATED HEREIN BY WAY OF REFERENCE.
        VAHAK SHALL NOT BE RESPONSIBLE IN ANY MANNER WHATSOEVER FOR ANY
        DISPUTE BETWEEN THE LORRY PROVIDER AND THE LOAD PROVIDER.</b>`
    },
    {
        headContent: `In order to be eligible to receive and/or qualify for the Cashback, the Load Provider shall be
        required to make payment for the transaction using Vahak Payment and should ensure that
        the transaction should satisfy all the other conditions, criterion as has been contained herein:`,
        subCategoryType: "a",
        subCategories: [
            {
                mainContent: `The transaction should be carried out within the Validity Period;`
            },
            {
                mainContent: `The payment for transaction made must be E-way bill verified and such E-way bill
                must have expired;`
            },
            {
                mainContent: `The Lorry Provider and the Load Provider should have their KYC and GST/PAN/RC (as
                    applicable) verified and the same should reflect in the records of the Company, at the
                    time of making the transaction; and`
            },
            {
                mainContent: `The entire payment for the transaction should have been made using Vahak Payments
                and no part of it should be pending and/or disputed.`
            }
        ],
        extraContent: `<br />When a transaction qualifies all the conditions mentioned in (a) to (d) above, the
        transaction will be referred to as <b>“Eligible Transaction”</b>.<br/>`
    },
    {
        headContent: `For the avoidance of doubt, it is made clear that for the purpose of calculating CTV, any
        amount of GST or applicable taxes etc, as paid by the Load Provider to the Lorry Provider as
        reflected in the invoice amount, shall be excluded.`
    },
    {
        headContent: `The Cashback is subject to the following:`,
        subCategoryType: "a",
        subCategories: [
            {
                mainContent: `The Individual Transaction Cashback Cap and the Cumulative Transaction Cashback
                Cap;`
            },
            {
                mainContent: `Maximum 1 (one) Eligible Transactions with a
                particular Load Provider and  Lorry Provider shall be considered for calculating CTV and Cashback. For the
                avoidance of doubt, it is made clear that all other Eligible Transactions that have not been
                entered into, by and between the Load Provider and the same Lorry Provider, shall be
                considered for calculating CTV and Cashback;`
            },
            {
                mainContent: `Payment value of each eligible transaction should be more than or equal to INR
                10,000 (Indian Rupees Ten Thousand only) and less than or equal to  INR  50,000
                (Indian Rupees Fifty Thousand only). Only these transactions will be eligible for cashback
                schemes;`
            },
            {
                mainContent: `Cumulative transaction value (via vahak payment across lifetime) for the eligible Load
                provider should be less than or equal to INR 10,00,000 (Indian Rupees Ten lakhs only).
                Only transactions up to this limit will be eligible for cashback schemes.`
            }
        ]
    },
    {
        headContent: `order to receive the Cashback, the User is required to share his/her bank account number and
        other details (as sought) on the Platform and post verification of the same, the Cashback shall
        be credited within 15 days from the expiry of the Validity Period or 15 days from the date the
        complete details were shared by the User on the Platform, whichever is later.`
    },
    {
        headContent: `The Company reserves the exclusive right to:`,
        subCategoryType: "a",
        subCategories: [
            {
                mainContent: `refuse Cashback to any User in whole or in part, without assigning any reason
                whatsoever;`
            },
            {
                mainContent: `amend, modify – in whole or in part, the Vahak - Cashback T&C, including but not limited
                to the Validity Period, Cashback Scheme etc; and`
            },
            {
                mainContent: `withdraw the Cashback Scheme(s) at any time without providing any reason and without
                providing any prior intimation or notice.`
            }
        ]
    },
    {
        headContent: `In case of any concern, query etc., please write an email to cs@vahak.in with the subject
        line ‘Online Payment Cashback incentive’ necessarily including the following details:`,
        subCategoryType: "a",
        subCategories: [
            {
                mainContent: `Load details;`
            },
            {
                mainContent: `Your communication details; and`
            },
            {
                mainContent: `Particulars of the dispute or query.`
            }
        ]
    },
    {
        headContent: `Disputes, if any, are subject to the exclusive jurisdiction of the competent courts at Bengaluru
        (Karnataka).`
    },
    {
        headContent: `Refer and Earn <b>(only)</b> Terms & Conditions:`,
        subCategories: [
            {
                mainContent: `Coins can be used for Cashback & VAS services only.`
            },
            {
                mainContent: `Coins can't be converted into Rupees`
            }
        ]
    }
];

export { cashbackTermsandConditions };
//# sourceMappingURL=cashbackTermsandConditions.js.map
